import Badge from "@mui/material/Badge";
import { BADGE_SIZE } from "./NavbarConstants";
import { Handbag } from "@phosphor-icons/react";
import { IconButton } from "@mui/material";
import { useTheme } from "../../../util/themes";

export const NavbarCart: React.FC<{ 
  cartCount: number; 
  onClick: () => void;
}> = ({ cartCount, onClick }) => {
  const theme = useTheme();

  return (
    <IconButton
      onClick={onClick}
      sx={{
        color: theme.colors.text.primary,
        '& svg': {
          color: theme.colors.text.primary,
          stroke: theme.colors.text.primary,
        },
      }}
    >
      <Badge 
        badgeContent={cartCount} 
        color="primary"
        sx={{
          '& .MuiBadge-badge': {
            fontSize: '0.6rem',
            height: BADGE_SIZE,
            minWidth: BADGE_SIZE,
            backgroundColor: theme.colors.text.primary,
            color: theme.colors.background.paper,
          }
        }}
      >
        <Handbag size={18} weight="regular" />
      </Badge>
    </IconButton>
  );
};














